import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2),
    },
  },
  infoContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      order: 1,
      flexWrap: "wrap",
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  nameText: {
    [theme.breakpoints.down("sm")]: {
      width: "40%",
    },
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      width: "90%",
    },
  },
  titleBox: {
    [theme.breakpoints.down("sm")]: {
      width: "50%",
      overflow: "hidden",
      marginRight: theme.spacing(1),
    },
    [theme.breakpoints.down("xs")]: {
      width: "90%",
      marginTop: theme.spacing(1),
    },
  },
}))

export default styles
